<script setup lang="ts">
import { rawHtmlVariants } from './index';

interface Props {
  content?: string;
  inlineStyles?: boolean;
  variant?: NonNullable<Parameters<typeof rawHtmlVariants>[0]>['variant'];
}

const props = defineProps<Props>();
const { variant } = toRefs(props);

const html = props.inlineStyles ? props.content : props.content?.replace(/style="[^"]*"/g, 'style=""');
</script>

<template>
  <div v-dompurify-html="html" class="prose" :class="rawHtmlVariants({ variant })" />
</template>

<style scoped>
@import '~/assets/css/mixins/_mixins.index.pcss';

.c-raw-html {
  --tw-prose-body: var(--theme-text-color);
  --tw-prose-headings: var(--theme-heading-color);
  --tw-prose-bold: var(--theme-heading-color);
  --tw-prose-bullets: var(--theme-text-color);

  text-align: left;

  &--center {
    text-align: center;
  }

  :deep(h1) {
    @mixin h1;
    text-transform: uppercase;
  }

  :deep(h2) {
    @mixin h2;
    text-transform: uppercase;
  }

  :deep(h3) {
    @mixin h3;
    text-transform: uppercase;
  }
}
</style>
